module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/9m-7259e4282ed0ff3f83f81aef66b9e014.jpg";